import { AxiosInstance } from 'axios';

import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { userProfile } from './userProfile.types';

const getUserProfile = (client: AxiosInstance) => async () => {
  const response = await client.get<ApiResponse<userProfile>>(API_ROUTES.GET_USER_PROFILE);
  return response.data.data;
};

export const userProfileQueries = () =>
  queryFactoryOptions<userProfile>({
    queryKey: ['user-profile'],
    queryFn: (client: AxiosInstance) => getUserProfile(client),
  });
